import PropTypes from 'prop-types';
import OddsBoostIndicatorImpl from './odds-boost-indicator.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * The view for bet info.
 *
 * @class OddsBoostIndicator
 * @memberof Mojito.Modules.OddsBoostIndicator
 */

/**
 * OddsBoostIndicator component prop types.
 *
 * @property {Mojito.Services.Bets.types.Bet} bet - The bet information.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Modules.OddsBoostIndicator
 */
const propTypes = {
    bet: PropTypes.object.isRequired,
    class: PropTypes.string,
};

export default UIView('OddsBoostIndicator', OddsBoostIndicatorImpl, propTypes);
